import React from "react";
import { MbForm } from "mibaby-frontend/Form";
import DateWidget from "./DateWidget";
import { FacebookPageSelectWidget } from "./FacebookPageSelectWidget";
import { FormPollField } from "@components/poll/form-poll.container";
import { ButtonWidget } from "mibaby-frontend/Form/widgets";

/**
 * The react-jsonschema-form renderer for DynamicForm forms: wraps `mibaby-frontend`'s
 * `MbForm` with this app's widget/field overrides (a date picker, the Facebook page
 * picker used by coreg forms, a poll-aggregation field for quiz/contest questions,
 * and a styled submit button), merged with any overrides the caller passes in.
 * Used directly (`loadComponent("MbForm")`) and wrapped by `./index.jsx`'s step form.
 *
 * Part of the Dynamic forms component — see docs/wiki/System/v2/leadgen/dynamic-forms.md.
 */

const overrides = {
  widgets: {
    FacebookPageSelectWidget,
    DateWidget,
    button: ButtonWidget,
  },

  fields: {
    FormPollField,
  },
};

export default props => {
  props = {
    ...overrides,
    ...props,
    widgets: { ...overrides.widgets, ...(props.widgets || {}) },
    fields: { ...overrides.fields, ...(props.fields || {}) },
  };

  return <MbForm {...props} />;
};
